module.exports = __webpack_public_path__ + "static/media/Brunei.e3d08620.png";